<div
	class="tw:fixed tw:z-50 tw:md:hidden tw:w-full tw:bottom-0 tw:left-0 tw:right-0 tw:p-4 tw:flex tw:justify-between tw:bg-white"
>
	<app-bottom-menu-item icon="home_work" routerLink="/internal-views/schools" routerLinkActive="active">
		School
	</app-bottom-menu-item>

	<app-bottom-menu-item icon="support_agent" routerLink="/internal-views/customer-support" routerLinkActive="active">
		Support
	</app-bottom-menu-item>

	<app-bottom-menu-item icon="space_dashboard" routerLink="/internal-views/features" routerLinkActive="active">
		Features
	</app-bottom-menu-item>

	<app-bottom-menu-item (click)="showMore()" icon="more_vert">More</app-bottom-menu-item>
</div>
